const baseURL = 'profile';
export const profilePages = {
	root: { base: () => `${baseURL}`, url: '' },
};